import SignupForm from "../../Forms/SignupForm.js";
import { Container } from "react-bootstrap";
import { ApiProvider } from "../../../context/Api";
const DownloadApp = () => {
  return (
    <Container>
      <ApiProvider>
        <SignupForm />
      </ApiProvider>
    </Container>
  );
};
export default DownloadApp;
